
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 0a3 3 0 00-3 3v18a3 3 0 003 3h7a3 3 0 003-3v-1.667a1 1 0 10-2 0V21a1 1 0 01-1 1H5a1 1 0 01-1-1V3a1 1 0 011-1h7a1 1 0 011 1v1.667a1 1 0 102 0V3a3 3 0 00-3-3H5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.253 7.342a1 1 0 00-1.506 1.317L18.797 11H10a1 1 0 100 2h8.796l-2.049 2.341a1 1 0 001.506 1.318l3.5-4a1 1 0 000-1.318l-3.5-4z","fill":"#fff"}})])
          )
        }
      }
    